module.exports = __webpack_public_path__ + "img/pl.18ba3dc2.svg";